import { CSSProperties, memo, ReactNode } from 'react'
import { Stack, styled } from '@mui/material'
import { NavLink } from 'react-router-dom'
import { IconMenuArrowDown } from './Icons'
import { menuAtom, MenuKeys, mobileMenuAtom } from './atoms'
import { useAtom, useSetAtom } from 'jotai'
import { navIndicatorAtom } from '../NavIndicator/atoms'
import { isMobile } from 'utils/userAgent'
import { MobileHead } from '../MobileHead'

export const LinkItem = styled(NavLink)`
  display: flex;
  align-items: center;
  height: 100%;
  color: ${({ theme }) => theme.color.text50};
  padding: 0 12px;
  position: relative;
  cursor: pointer;

  &.active {
    color: rgba(160, 238, 9, 1);
    background-color: rgba(30, 35, 41, 1);
    svg.arrow_down {
      transform: rotate(-180deg);
    }
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    font-size: 14px;
  }

  svg.arrow_down {
    margin-left: 4px;
    transition: all 0.4s ease;
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    flex-direction: column;
    align-items: start;
    width: 100%;
    height: unset;
    padding: 0 8px;

    &.nav-item {
      padding: 0;
    }
  }
`
const Item = styled(Stack)`
  flex-direction: row;
  align-items: center;
  ${({ theme }) => theme.breakpoints.down('md')} {
    justify-content: space-between;
    width: 100%;
    height: 56px;
    font-weight: 600;
    font-size: 16px;
    padding: 0 8px;
  }
`
const ItemArrow = styled(IconMenuArrowDown)`
  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 12px;
    height: 12px;
  }
`
const MenuItemPopupWrap = styled(Stack)`
  position: absolute;
  top: 100%;
  background-color: rgba(30, 35, 41, 1);
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
  box-shadow: 0 1px 2px rgb(0 0 0 / 5%);

  ${({ theme }) => theme.breakpoints.down('md')} {
    position: static;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 100;
  }
`

export const MenuItem = memo<{
  menuKey?: MenuKeys
  children?: ReactNode
  to?: string
  popup?: ReactNode
  id?: string
  direction?: 'left' | 'right'
  hideArrow?: boolean
  style?: CSSProperties
  className?: string
}>(
  ({
    menuKey,
    children,
    to = '',
    popup,
    id,
    direction = 'left',
    hideArrow = false,
    style = {},
    className = '',
  }) => {
    const [menu, setMenu] = useAtom(menuAtom)
    const setShowMenu = useSetAtom(mobileMenuAtom)
    const isIn = menuKey && menu === menuKey
    const Wrap = to ? LinkItem : 'div'
    const setNavIndicator = useSetAtom(navIndicatorAtom)

    const popupStyle: CSSProperties = {}
    if (direction === 'right') {
      popupStyle.right = 0
    } else {
      popupStyle.left = 0
    }
    return (
      <LinkItem
        id={id}
        to={to}
        as={Wrap}
        style={style}
        className={className + ` ${isIn ? 'active' : ''}`}
        onMouseEnter={(event) => {
          if (isMobile) {
            // do nothing
          } else {
            if (menuKey) {
              setMenu(menuKey)
            }

            const bounding = event.currentTarget.getBoundingClientRect()

            setNavIndicator({
              left: bounding.left + 'px',
              width: bounding.width + 'px',
            })
          }
        }}
        onMouseLeave={() => {
          setMenu(0)
          setNavIndicator((p) => {
            return { ...p, width: 0 }
          })
        }}
        onClick={() => {
          if (isMobile) {
            if (menuKey) {
              if (menuKey === menu) {
                setMenu(0)
              } else {
                setMenu(menuKey)
              }
            }
          }

          if (!popup) {
            setShowMenu(false)
          }
        }}
      >
        <Item>
          {children}
          {!!popup && !hideArrow && <ItemArrow className={'arrow_down'} />}
        </Item>
        {isIn && popup && (
          <MenuItemPopupWrap
            style={popupStyle}
            onClick={(event) => {
              if (isMobile) {
                event.stopPropagation()
              }
            }}
          >
            {popup}
          </MenuItemPopupWrap>
        )}
        {/* {id === 'zk_connect_button' && (
          <MenuItemPopupWrap style={style}>{popup}</MenuItemPopupWrap>
        )} */}
      </LinkItem>
    )
  },
)
